module.exports = __webpack_public_path__ + "img/bcdc.170a0971.png";